import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [{
  path: '', loadChildren: () => import('./members-search/members-search.module').then(m => m.MembersSearchModule)
},
{ path: 'search', loadChildren: () => import('./members-search/members-search.module').then(m => m.MembersSearchModule) }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class InfoPageRoutingModule { }
